import { ErrorHandler, Injectable } from "@angular/core";

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|ChunkLoadError|Loading chunk [\w-]+ failed/i;
const RELOAD_STORAGE_KEY = "condor-enterprise-chunk-reload-at";
const RELOAD_COOLDOWN_MS = 10000;

/**
 * Tras un deploy, una pestaña abierta desde antes puede referenciar un chunk lazy
 * que el servidor ya no sirve (nombre con hash de la build anterior). Ese fetch
 * fallido llega acá como error global; se resuelve con un reload duro en vez de
 * dejar la navegación rota. El cooldown evita loop de reload si el reload no soluciona el error.
 */
@Injectable({ providedIn: "root" })
export class ChunkErrorHandler extends ErrorHandler {
  public override handleError(error: unknown): void {
    const message: string = error instanceof Error ? error.message : String(error);

    if (CHUNK_ERROR_PATTERN.test(message) && this.puedeRecargar()) {
      sessionStorage.setItem(RELOAD_STORAGE_KEY, String(Date.now()));
      this.recargar();
      return;
    }

    super.handleError(error);
  }

  /**
   * Aislado en un metodo aparte para poder espiarlo en los tests:
   * window.location no es configurable en Chrome, no se puede mockear.
   */
  protected recargar(): void {
    window.location.reload();
  }

  private puedeRecargar(): boolean {
    const lastReload: number = Number(sessionStorage.getItem(RELOAD_STORAGE_KEY) ?? 0);
    return Date.now() - lastReload > RELOAD_COOLDOWN_MS;
  }
}
